
import { useFormik } from "formik";
import { useState } from "react";

import Modal from "react-bootstrap/Modal";
import eyeImg from 'assets/images/eye.png';
import { AiFillEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { ToastContainer, toast } from "react-toastify";
import { folderService } from "services/folder.service";

import * as Yup from 'yup';
function CreateFolder(props) {
  const { show, handleClose, setLoading, data, setData } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [error, setError] = useState(null);
  const formik = useFormik({
    initialValues: {
      title: "",
      link: '',
      password: ''
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      title: Yup.string().required("Please enter Folder name").max(20, 'First Name must be at most 15 characters'),
      link: Yup.string().required("Please enter Google Drive Link"),
      password: Yup.string().required("Please enter password").min(4,"Password should be at least 4 characters").max(10,"Password should be at most 10 characters long"),
    }),
    onSubmit: async (values) => {
      try {
        const response = await folderService.addfolder(values);
        toast.success(response?.data?.message, { autoClose: 2000 });
        setShowPassword(false)
        handleClose()
        formik.resetForm(values)
        const newFolders = [response?.data?.data, ...data?.folders]
        setData({
          totalFolders: newFolders?.length,
          folders: newFolders
        })
        setTimeout(() => {
          setLoading(false);
        }, 1000);

        setLoading(true)
      } catch (err) {
        console.error(err?.response?.data?.message);
        setError(err?.response?.data?.message);
      }
    },
  });
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const generatePassword = () => {
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+~`|}{[]:;?><,./-=';

    const passwordLength = 10;

    let generatedPassword = '';
    for (let i = 0; i < passwordLength; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      generatedPassword += characters[randomIndex];
    }
    formik.setFieldValue('password', generatedPassword)
    // setPassword(generatedPassword);
  };

  return (
    <>
      <Modal show={show} className="modal-common" onHide={(values)=>{
        handleClose()
             formik.resetForm(values)
      }}>
        <Modal.Header closeButton>Create Folder</Modal.Header>
        <Modal.Body>
          <form>
            <div className="mb-30">
              <label className="py-2">Enter Folder Name</label>
              <br />
              <input
                type="text"
                placeholder="Enter Folder Name"
                className="form-control rounded-3 bg-cyan w-100"
                name="title"
                id="title"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.title}
                autoComplete="current-title"

              />
              {formik.touched.title && formik.errors.title ? (
                <div className="text-danger">{formik.errors.title}</div>
              ) : null}
            </div>
            <div className="mb-30">
              <label className="py-2">Google Drive Link</label>
              <br />
              <input
                type="text"
                placeholder="Google Drive Link"
                className="form-control rounded-3 bg-cyan w-100"
                name="link"
                id="link"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.link}
                autoComplete="current-link"
              />
              {formik.touched.link && formik.errors.link ? (
                <div className="text-danger">{formik.errors.link}</div>
              ) : null}
            </div>
            <div className="mb-30">
              <label className="py-2">Create Password</label>
              <br />
              <div className="d-flex px-3 justify-content-between rounded-3 form-control-container w-100" >
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Create Password"
                  className="bg-transparent border-0 w-100 text-white"
                  name="password"
                  id="password"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.password}
                  autoComplete="current-password"
                />
                <h1
                  className="password-toggle-icon"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? <AiOutlineEyeInvisible fill="#fff" size={24}  /> : <img style={{ filter: 'invert(1) brightness(100)' }} src={eyeImg} />}
                </h1>
              </div>
              {formik.touched.password && formik.errors.password ? (
                <div className="text-danger">{formik.errors.password}</div>
              ) : null}
              <span className="genrate-password text-uppercase cursor-pointer" onClick={generatePassword}>
                Generate Password
              </span>
            </div>
            <button type="button"
              onClick={() => {
                setIsLoading(true);
                setTimeout(() => {
                  setIsLoading(false);
                  formik.handleSubmit();
                }, 2000);
              }}
              disabled={isLoading}
              className="btn btn-primary modal-blue-btn text-capitalize w-100 text-white"
            >
              {isLoading ? "Submitting..." : "Submit"}
            </button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CreateFolder;
